import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getCustomFonts } from 'ContentData/selectors/fonts';
import I18n from 'I18n';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIStepIndicator from 'UIComponents/connectedStep/UIStepIndicator';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AddCustomFont from './AddCustomFont';
import EditCustomFont from './EditCustomFont';
import ManageCustomFont from './ManageCustomFont';
import { FONT_FILE_TYPES, ModalPages } from 'ContentData/constants/fonts';
import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import { createTracker } from 'usage-tracker';
import events from 'ContentComponents/events.yaml';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.font.modals.upload.${key}`;
const mapStateToProps = state => {
  return {
    customFonts: getCustomFonts(state)
  };
};
const connector = connect(mapStateToProps);
//TODO add in usage tracking for whole feature!

class CustomFontsUploadModal extends PureComponent {
  constructor(props) {
    super(props);
    this.fontNameErrorMessage = updatedName => {
      const {
        customFonts
      } = this.props;
      const {
        page,
        fontName
      } = this.state;
      const name = updatedName || fontName || '';
      if (fontName && page !== ModalPages.MANAGE) {
        // TODO fix edit page error handling to be able to check for unique name
        // Currently it doesnt work because its comparing again a list that contains itself, so will require some error handling refactoring
        // In the meantime, save is blocked if a font is changed to a dupe name because the request fails
        if (page === ModalPages.ADD && Object.keys(customFonts).includes(name)) {
          return i18nKey('error.fontMustHaveUniqueName');
        } else if (name.includes(' - ')) {
          return i18nKey('error.fontNameCannotContainSpaceDashSpace');
        }
      }
    };
    this.onUpdate = fontStateUpdates => {
      // Invalid font name error messages take precedance over other error types
      // once name is valid, other errors can be shown
      // TODO refactor error messaging so that multiple errors can show at once
      fontStateUpdates.errorMessage = this.fontNameErrorMessage(fontStateUpdates.fontName) || fontStateUpdates.errorMessage;
      this.setState(Object.assign({
        page: this.state.page
      }, fontStateUpdates));
    };
    this.changePage = page => {
      this.setState({
        page,
        errorMessage: undefined
      });
    };
    this.addStyle = (styleIndex, fileToAdd) => {
      const {
        fontStyles = []
      } = this.state;
      const newStyles = [...fontStyles];
      newStyles[styleIndex] = {
        fileName: fileToAdd.name,
        style: fontStyles[styleIndex].style
      };
      return newStyles;
    };
    this.addFiles = (filesToAdd, styleIndex) => {
      if (filesToAdd) {
        const {
          fontFiles = [],
          fontFilesUploaded = []
        } = this.state;
        let newErrorMessage;

        //filter out dupe file names
        const fontFilesNames = fontFiles.map(file => file.fileName);
        const filesToAddFiltered = Object.values(filesToAdd).filter(file => {
          const fileExists = fontFilesNames.includes(file.name);
          if (fileExists) {
            newErrorMessage = i18nKey('error.noDuplicateFileNames');
          }
          const fileTypeNotSupported = !FONT_FILE_TYPES.includes(file.type);
          if (fileTypeNotSupported) {
            newErrorMessage = i18nKey('error.fileTypeNotSupported');
          }
          return !fileExists;
        });
        if (!filesToAddFiltered.length) {
          this.onUpdate({
            errorMessage: newErrorMessage
          });
          return;
        }
        const newFontFilesUploaded = filesToAddFiltered ? [...fontFilesUploaded].concat([...filesToAddFiltered]) : fontFilesUploaded;
        const newFontFilesToAdd = Array.from(filesToAddFiltered).map(file => {
          return {
            fileName: file.name,
            fileSize: file.size
          };
        });
        const newFontFiles = [...fontFiles].concat(newFontFilesToAdd);

        // style index should only present when 1 file added, multiple not allowed
        const newStyles = !isNullOrUndefined(styleIndex) && this.addStyle(styleIndex, filesToAddFiltered[0]);
        this.onUpdate(Object.assign({
          fontFilesUploaded: newFontFilesUploaded,
          fontFiles: newFontFiles
        }, newStyles ? {
          fontStyles: newStyles
        } : {}, {
          errorMessage: newErrorMessage
        }));
      }
    };
    this.removeStyle = (index, fileName, alsoRemoveVariant) => {
      const {
        fontStyles
      } = this.state;
      return fontStyles && fontStyles.reduce((hash, style, styleIndex) => {
        if (fileName && fileName === style.fileName) {
          if (!alsoRemoveVariant) {
            hash.push({
              fileName: undefined,
              style: style.style
            });
          }
        } else if (fileName || !fileName && index !== styleIndex) {
          hash.push(style);
        }
        return hash;
      }, []);
    };
    this.removeFile = (index, fileName, alsoRemoveVariant) => {
      const {
        fontStyles,
        fontFiles,
        fontId,
        fontFilesUploaded
      } = this.state;
      if (alsoRemoveVariant && fontStyles && fontStyles.length <= 1) {
        this.onUpdate({
          errorMessage: i18nKey('error.noEmptyStyles')
        });
        return;
      }
      const newFiles = fontFiles && fontFiles.filter(fontFile => fontFile.fileName !== fileName);
      const newFilesUploaded = fontFilesUploaded && fontFilesUploaded.filter(fontFile => fontFile.name !== fileName);
      const newStyles = this.removeStyle(index, fileName, alsoRemoveVariant);
      this.onUpdate(Object.assign({
        fontFilesUploaded: newFilesUploaded,
        fontFiles: newFiles
      }, newStyles && {
        fontStyles: newStyles
      }, fontId && {
        fontEdited: true
      }));
    };
    this.closeModal = () => {
      const {
        onCancel
      } = this.props;
      if (this.tracker) {
        this.tracker.track('ContentComponentsInteraction', {
          action: 'custom-fonts-upload-modal-closed'
        });
      }
      onCancel();
    };
    this.renderErrorMessage = message => {
      const {
        page
      } = this.state;
      return /*#__PURE__*/_jsx(UIAlert, {
        type: "danger",
        className: "m-left-10 m-right-10" + (page === ModalPages.MANAGE ? " m-top-5" : ""),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: message
        })
      });
    };
    this.tracker = createTracker({
      events
    });
    this.state = {
      page: props.openingPage || ModalPages.MANAGE
    };
  }
  componentDidMount() {
    if (this.tracker) {
      this.tracker.track('ContentComponentsInteraction', {
        action: 'custom-fonts-upload-modal-opened'
      });
    }
  }
  render() {
    const {
      page,
      fontName,
      fontFiles,
      fontFilesUploaded,
      fontStyles,
      fontId,
      fontEdited,
      fontAdded,
      errorMessage
    } = this.state;
    return /*#__PURE__*/_jsxs(UIModalPanel, {
      onEsc: this.closeModal,
      "data-selenium": "font-upload-modal-panel",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`${ModalPages[page].toLowerCase()}.header`)
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: this.closeModal,
          "data-selenium": `font-upload-modal-close`
        })]
      }), page !== ModalPages.MANAGE && /*#__PURE__*/_jsx(UIGrid, {
        children: /*#__PURE__*/_jsx(UIStepIndicator, {
          direction: "horizontal",
          stepIndex: Object.keys(ModalPages).indexOf(page),
          stepNames: [I18n.text(i18nKey('addFontStep')), I18n.text(i18nKey('editFontStep'))],
          use: "compact",
          className: "m-top-6 m-bottom-4"
        })
      }), errorMessage && this.renderErrorMessage(errorMessage), page === ModalPages.ADD && /*#__PURE__*/_jsx(AddCustomFont, {
        changePage: this.changePage,
        handleUpdate: this.onUpdate,
        fontName: fontName,
        fontFiles: fontFiles,
        addFiles: this.addFiles,
        removeFile: this.removeFile,
        hasValidName: !this.fontNameErrorMessage()
      }), page === ModalPages.EDIT && /*#__PURE__*/_jsx(EditCustomFont, {
        changePage: this.changePage,
        handleUpdate: this.onUpdate,
        fontName: fontName,
        fontFiles: fontFiles,
        fontFilesUploaded: fontFilesUploaded,
        fontStyles: fontStyles,
        addFiles: this.addFiles,
        removeFile: this.removeFile,
        fontId: fontId,
        fontEdited: fontEdited,
        usageTracker: this.tracker,
        hasValidName: !this.fontNameErrorMessage()
      }), page === ModalPages.MANAGE && /*#__PURE__*/_jsx(ManageCustomFont, {
        changePage: this.changePage,
        handleUpdate: this.onUpdate,
        onCancel: this.closeModal,
        fontAdded: fontAdded,
        usageTracker: this.tracker
      })]
    });
  }
}
export default connector(CustomFontsUploadModal);